// 'success' 'error' 'warning' 'info'
export default {
  OPEN: 'open',
  CLOSE: 'close',
};
